import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/core/AppLayout";
import { InvoicesWorkspace } from "@/components/invoices/InvoicesWorkspace";
import { InvoiceClientRail } from "@/components/invoices/InvoiceClientRail";
import { InvoiceQuickUpload } from "@/components/invoices/InvoiceQuickUpload";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const KEY = "core_fatture_cliente";

export default function InvoicesPage() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const [clients, setClients] = useState(null);
  const [tick, setTick] = useState(0);
  const wanted = params.get("cliente") || localStorage.getItem(KEY) || "all";
  const loadClients = useCallback(() => api.get("/fatture/clienti").then((r) => setClients(r.data)), []);
  useEffect(() => { loadClients(); }, [loadClients]);
  const selected = !clients || wanted === "all" || clients.some((c) => c.id === wanted) ? wanted : "all";
  const client = clients?.find((c) => c.id === selected);
  const select = (id) => {
    localStorage.setItem(KEY, id);
    setParams(id === "all" ? {} : { cliente: id });
  };
  const changed = () => { loadClients(); setTick((t) => t + 1); };
  return (
    <div data-testid="invoices-page">
      <PageHeader eyebrow="Amministrazione" title={client ? client.ragione_sociale : "Fatture"}
        subtitle={client ? "Fatture del cliente" + (user.role === "admin" ? " di tutti i soci." : " caricate da te.")
          : user.role === "admin" ? "Tutte le fatture dei soci." : "Le tue fatture: sono visibili solo a te e all'amministratore."} />
      <div className="grid grid-cols-[280px_1fr] gap-6 items-start">
        <InvoiceClientRail clients={clients} selected={selected} onSelect={select} />
        <div className="min-w-0" data-testid={client ? "inv-client-view" : "inv-all-view"}>
          {client ? (
            <>
              <InvoiceQuickUpload key={client.id} clientId={client.id} clientName={client.ragione_sociale} onCreated={changed} />
              <InvoicesWorkspace key={client.id} clientId={client.id} refreshKey={tick} onChanged={loadClients} hideNew />
            </>
          ) : clients && <InvoicesWorkspace key="all" refreshKey={tick} onChanged={loadClients} />}
        </div>
      </div>
    </div>
  );
}
